// extracted by css-extract-rspack-plugin
export default {"root":"wN_uhoLt4MIGstPk"};